class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector("#search-input");
    this.predictiveSearchResults = this.querySelector("#search-results");

    if (!this.input || !this.predictiveSearchResults) return;

    this.input.addEventListener(
      "input",
      this.debounce(() => {
        this.onChange();
      }, 300)
    );

    this.input.addEventListener("keypress", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        //this.onEnter();
      }
    });
  }

  onFocusOut() {
    $(this.predictiveSearchResults).fadeOut();
    this.input.value = "";
  }

  onChange() {
    const searchTerm = encodeURIComponent(this.input.value.trim());

    if (!searchTerm.length) {
      $(this.predictiveSearchResults).fadeOut(function () {
        $(".search__initial").fadeIn();
      });
      $(".header__search-tabs-wrapper").fadeIn();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onEnter() {
    const q = this.input?.value?.trim();
    if (q) {
      window.location.href = `/search?q=${encodeURIComponent(q)}`;
    }
  }

  getSearchResults(searchTerm) {
    const resourceType = this.input?.getAttribute("data-type") || "product";
    fetch(
      `/search?q=${searchTerm}&type=${resourceType}&options[unavailable_products]=show&options[prefix]=last&view=predictive`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();

          throw error;
        }

        return response.text();
      })
      .then((text) => {
        // console.log({ text });
        if (text.indexOf("no-results") != -1) {
          $(".navbar__search").addClass("search-results--no-results");
          $(".header__search-tabs-wrapper").fadeIn();
          return;
        }

        $(".navbar__search").removeClass("search-results--no-results");
        $(".header__search-tabs-wrapper").fadeOut();

        // const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        const resultsMarkup = text;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        if (typeof lozad === "function") {
          lozad(this.predictiveSearchResults.querySelectorAll("img.lozad")).observe();
        }

        if ($(".search__initial").is(":visible")) {
          $(this.predictiveSearchResults).hide();

          $(".search__initial").fadeOut(() => {
            this.open();
          });
        } else {
          this.open();
        }

        if ($(this.predictiveSearchResults).is(":visible")) {
          //$('.header__search-tabs-wrapper').fadeIn();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    $(this.predictiveSearchResults).fadeIn();
    $(".header__search-tabs-wrapper").fadeOut();
  }

  close() {
    $(this.predictiveSearchResults).fadeOut();
  }

  debounce(fn, wait) {
    let t;
    const self = this;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(self, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);